import React from 'react';
import { useSelector } from 'react-redux';
import { Divider, Box } from '@mui/material';
import * as ShopSelectors from 'selectors/ShopSelectors';
import { isMethodInLimits } from 'common/modules/payments/paymentMethods';
import { PaymentMethodRow, PaymentMethodRowInfo } from '../../components/PaymentMethodRow';
import { PaymentMethodHeaderRow } from '../../components/PaymentMethodHeaderRow';

const rentlePaymentsMethods: PaymentMethodRowInfo[] = [
	{
		name: 'CARD_ONLINE',
		description: 'Visa, Mastercard, ApplePay, GooglePay',
	},
	{
		name: 'MOBILEPAY',
		disabled: true,
		helperText: 'MobilePay is temporarily disabled - technical updates in progress by the issuer.',
	}, // Remove MobilePay temporarily because of Adyen authorisation issue
	{ name: 'TRUSTLY' },
	{ name: 'PAYTRAIL' },
];

const PaymentMethods = () => {
	const shop = useSelector(ShopSelectors.activeShopData)!;
	const shopCurrency = shop.publicInfo.currency;
	const shopCountry = shop.publicInfo.country ?? 'FI';

	const validShopPaymentMethods: PaymentMethodRowInfo[] = rentlePaymentsMethods.map((m) => ({
		...m,
		hidden: !isMethodInLimits(m.name, {
			recurringRequired: false,
			currency: shopCurrency.code,
			country: shopCountry,
			paymentIsInIframe: false,
			hasDeposit: false,
			isCustomDomain: false,
		}),
	}));

	return (
		<Box>
			<PaymentMethodHeaderRow />
			{validShopPaymentMethods.map((methodProps, index) => {
				const lastItem = index === validShopPaymentMethods.length - 1;
				const showDivider = !lastItem && !methodProps.hidden;
				return (
					<React.Fragment key={methodProps.name}>
						<Box my={2}>
							<PaymentMethodRow {...methodProps} />
						</Box>
						{showDivider && <Divider />}
					</React.Fragment>
				);
			})}
		</Box>
	);
};

export default PaymentMethods;
